import styles from './ModifierCheckbox.module.scss';
import { Checkbox, LocationManagedChip } from '@components';

export interface ModifierCheckboxProps {
	label: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	/* The stop's location (Location Manager) has an opinion on this modifier. */
	fromLocation?: boolean;
	isAdmin?: boolean;
	disabled?: boolean;
}

export const ModifierCheckbox = (props: ModifierCheckboxProps) => {
	const {
		label,
		checked,
		onChange,
		fromLocation = false,
		isAdmin = false,
		disabled = fromLocation && !isAdmin,
	} = props;

	return (
		<div className={styles.modifierRow}>
			<Checkbox
				name={''}
				label={label}
				value={''}
				onChange={(e) => onChange(e.target.checked)}
				checked={checked}
				disabled={disabled}
			/>
			{fromLocation && <LocationManagedChip type={isAdmin ? 'suggested' : 'required'} />}
		</div>
	);
}
